import StoreFirebaseModel from './StoreFirebaseModel';

export default class StoreCoupon extends StoreFirebaseModel {

}

StoreCoupon.collection = 'coupons';

// Round.addListener((datas) => { alert(`update ${datas.length}`) })
// Round.add({ test: true })
// Round.getItems();